import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./ScrollToTop";
import NotFound from "./Components/Pages/NotFound";
import Writeup from './Components/Pages/Writeup';
import ProjectsPage from './Components/Pages/ProjectsPage';
import AboutMe from './Components/Pages/AboutMe';
import AwsCommandBuilder from "./Components/Pages/AwsCommandBuilder";
import { realtime } from "./firebase";
import { onValue, ref } from 'firebase/database';
import DataContext from "./DataContext"
import Workshops from "./Components/Pages/Workshops"
import CVEPage from "./Components/Pages/CVE";
import Certifications from "./Components/Pages/Certifications";

const App = () => {

  const [projects, setProjects] = useState([]);
  const [writeups, setWriteups] = useState([]);
  const [certs, setCerts] = useState([]);
  const [workshops, setWorkshops] = useState([]);

  useEffect(() => {
    setProjects([]);
    setWriteups([]);
    setCerts([]);
    setWorkshops([]);

    onValue(ref(realtime, '/projects'), (snapshot) => {
      const data = snapshot.val(); 
      const reverseProject = []; 

      if (data !== null) {
        Object.keys(data).forEach(key => {
          reverseProject.unshift({ id: key, data: data[key] });
        })

        setProjects(reverseProject);
      }
    })

    onValue(ref(realtime, '/writeups'), (snapshot) => {
      const data = snapshot.val(); 
      const reverseWriteup = [];

      if (data !== null) {
        Object.keys(data).forEach(key => {
          reverseWriteup.unshift({ id: key, data: data[key] });
        })

        setWriteups(reverseWriteup);
      }
    })

    onValue(ref(realtime, '/certifications'), (snapshot) => {
      const data = snapshot.val(); 
      const reverseCerts = [];

      if (data !== null) {
        Object.keys(data).forEach(key => {
          reverseCerts.unshift({ id: key, data: data[key] });
        })

        setCerts(reverseCerts);
      }
    })

    onValue(ref(realtime, '/workshops'), (snapshot) => {
      const data = snapshot.val(); 
      const reverseWorkshops = [];

      if (data !== null) {
        Object.keys(data).forEach(key => {
          reverseWorkshops.unshift({ id: key, data: data[key] });
        })

        setWorkshops(reverseWorkshops);
      }
    })
  }, [])

  return (
    <BrowserRouter>
      <ScrollToTop />
      <DataContext.Provider value={{ projects, writeups, certs, workshops }}>
        <Routes>
          <Route path="/" element={<AboutMe />}></Route>
          <Route path="/projects" element={<ProjectsPage />}></Route>
          <Route path="/writeup" element={<Writeup />}></Route>
          <Route path="/workshops" element={<Workshops />}></Route>
          <Route path="/cve" element={<CVEPage />}></Route>
          <Route path="/certifications" element={<Certifications />}></Route>
          <Route path="/aws-command-builder" element={<AwsCommandBuilder />}></Route>
          <Route path="/*" element={<NotFound />}></Route>
        </Routes>
      </DataContext.Provider>
    </BrowserRouter>
  )
}

export default App
